import { FormFields } from "./CreateForm";
import React, { useState } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import useFetch from "./helpers/useFetch";
import { PageHeaderLink } from "./helpers/elements";
import { useDeviceWidth } from "./useDeviceWidth";
import { AppDetailLeftNav } from "./UpdateAppDetail";
import axios from "axios";

const UpdateAppDownloadLinks = () => {
    const { appNameId } = useParams();
    const { app } = useLoaderData();
    const appData = app?.data;
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    // const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${appId}/`);
    const [isSubmit, setIsSubmit] = useState(false);
    const [updateAppDownloadLinksData, setUpdateAppDownloadLinksData] = useState({});
    const [updateAppDownloadLinksResponseData, setUpdateAppDownloadLinksResponseData] = useState({});

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setUpdateAppDownloadLinksData(values => (
            { ...values, [name]: value }
        ));
    }

    const showLoadingState = (e) => {
        setIsSubmit(true);
    };

    const updateDownloadLinksForm = (event) => {
        event.preventDefault();
        const formData = new FormData();
        if (updateAppDownloadLinksData?.playstore_link) {
            formData.append("playstore_link", updateAppDownloadLinksData?.playstore_link);
        }
        if (updateAppDownloadLinksData?.appstore_link) {
            formData.append("appstore_link", updateAppDownloadLinksData?.appstore_link);
        }
        if (updateAppDownloadLinksData?.external_link) {
            formData.append("external_link", updateAppDownloadLinksData?.external_link);
        }

        const updateAppURL = `${process.env.REACT_APP_BASE_URL}/app/${appNameId}/`;
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
            'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
        };
        const fetchConfig = {
            method: 'PATCH',
            headers: headers,
            mode: 'cors',
            // body: formData,
            data: formData,
            cache: 'default',
        };
        // fetch(updateAppURL, fetchConfig)
        axios(updateAppURL, fetchConfig)
            .then(response => {
                if (response.status !== 200) throw Error(response.error);
                // return response.json()
                return response.data;
            })
            .then(data => {
                setIsSubmit(false);
                setUpdateAppDownloadLinksResponseData({
                    message: "App update successful",
                    successful: true,
                    error: false
                });
            })
            .catch((error) => {
                let error_message;
                if (error.status === 401) {
                    error_message = "Kindly login to update your Profile"
                } else if (error.status === 400) {
                    error_message = "Unable to perform update. Kindly fix any form errors and re-submit"
                } else if (error.status === 500) {
                    error_message = "Check your internet connection"
                } else {
                    // There is no network connection or the Server is not up.
                    error_message = "Network Error"
                }
                setUpdateAppDownloadLinksResponseData({
                    message: error_message,
                    successful: false,
                    error: true
                });
                // reset the isSubmit loader
                setIsSubmit(false);
            });
    };

    return (
        <section className={"flex flex-row flex-nowrap justify-start pct:h-100 dark:bg-111314"}>
            {
                windowWidth >= deviceWidthEnum.laptop
                    ? <AppDetailLeftNav appName={appData?.name} pageName={"Download-links"} />
                    : null
            }
            <form action={""} method={"PATCH"} onSubmit={updateDownloadLinksForm} className={"pct:w-100 lg:pct:w-56|mg-r-auto|mg-t8"}>
                {
                    windowWidth < deviceWidthEnum.laptop
                        ? <PageHeaderLink headerTitle={"Update download links"} />
                        : <PageHeaderLink headerTitle={"Download links"} />
                }
                {
                    updateAppDownloadLinksResponseData?.successful
                        ? <div
                            className="relative mg-x-auto text-center pct:w-64 pad-y2 radius-sm bg-green-inverse color-green">
                            {updateAppDownloadLinksResponseData.message}
                        </div>
                        : null
                }
                {
                    updateAppDownloadLinksResponseData?.error
                        ? <div
                            className="relative mg-x-auto text-center pct:w-64 pad-y2 radius-sm bg-red-inverse color-red">
                            {updateAppDownloadLinksResponseData.message}
                        </div>
                        : null
                }

                <FormFields
                    useDefaultInput
                    type={"url"}
                    label_value={"Play Store"}
                    id={"id-new-app-playstore-link"}
                    name={"playstore_link"}
                    defaultValue={appData?.playstore_link}
                    placeholder={"PlayStore download link"}
                    onChange={handleChange}
                >
                </FormFields>

                <FormFields
                    useDefaultInput
                    type={"url"}
                    id={"id-new-app-appstore-link"}
                    name={"appstore_link"}
                    defaultValue={appData?.appstore_link}
                    label_value={"AppStore"}
                    placeholder={"AppStore download link"}
                    onChange={handleChange}
                >
                </FormFields>

                <FormFields
                    useDefaultInput
                    type={"url"}
                    id={"id-new-app-external-link"}
                    name={"external_link"}
                    defaultValue={appData?.external_link}
                    label_value={"Other Store"}
                    placeholder={"Link to other Store download link"}
                    onChange={handleChange}
                >
                </FormFields>

                <div className={"sticky bottom-0 mg-t-4 mg-b2 pad-t4 pad-b4 bg-white-solid dark:bg-111314"}>
                    <button
                        type={"submit"}
                        className={"d-block pct:w-64 max-w-480 h-7 lh-7 mg-x-auto pad-x2 border-0 bg-green color-white radius decoration-none cursor-pointer disabled:bg-green-inverse disabled:cursor-not-allowed"}
                        disabled={!(updateAppDownloadLinksData?.playstore_link || updateAppDownloadLinksData?.appstore_link || updateAppDownloadLinksData?.external_link)}
                        onClick={showLoadingState}
                    >
                        {isSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Save"}
                    </button>
                </div>
            </form>
        </section>
    );
}
export default UpdateAppDownloadLinks;